import { render, staticRenderFns } from "./ShowGravatar.vue?vue&type=template&id=de67e03e&scoped=true"
import script from "./ShowGravatar.vue?vue&type=script&lang=js"
export * from "./ShowGravatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de67e03e",
  null
  
)

export default component.exports